export const languageSkills = [
  { name: 'English', value: 95 },
  { name: 'Urdu', value: 85 },
  { name: 'Punjabi', value: 60 },
  { name: 'German (Learning)', value: 40 },
]

export const hardSkills = [
  {
    label: 'Frontend Development',
    detail:
      'React.js, Next.js, Angular, TypeScript, JavaScript (ES6+), HTML5, CSS3, SCSS, Tailwind CSS, Material UI, Bootstrap, Radix UI',
    value: 95,
  },
  {
    label: 'State Management & Data',
    detail: 'Redux, Context API, React Query (TanStack Query), RxJS, GraphQL, REST APIs',
    value: 90,
  },
  {
    label: 'React Ecosystem',
    detail: 'React Hooks, Custom Hooks, React Router, React Testing Library, Zustand',
    value: 90,
  },
  {
    label: 'Architecture & Practices',
    detail:
      'Micro Frontends (Module Federation), Component-Driven Development, Design Systems, Scalable UI Architecture, Web Accessibility (WCAG), Responsive Design, Cross-Browser Compatibility, Agile/Scrum',
    value: 99,
  },
  {
    label: 'Performance Optimization',
    detail: 'Core Web Vitals, Code Splitting, Lazy Loading, Memoization, Bundle Size Optimization, SSR/SSG',
    value: 90,
  },
  {
    label: 'Testing & Quality',
    detail: 'Jest, Cypress, Storybook, Unit Testing, Integration Testing, End-to-End (E2E) Testing',
    value: 70,
  },
  {
    label: 'Backend & Integrations',
    detail: 'Node.js, Express.js, .NET, Blazor, Google Analytics 4 (GA4), Optimizely, Contentsquare, Adobe Target',
    value: 80,
  },
  {
    label: 'DevOps & Cloud',
    detail: 'GitHub Actions, GitLab CI/CD, Bitbucket Pipelines, Docker, AWS, Azure, Nginx',
    value: 75,
  },
  {
    label: 'Tools & Collaboration',
    detail: 'Git, GitHub, Jira, Confluence, Figma, Postman',
    value: 80,
  },
  {
    label: 'AI & Developer Productivity',
    detail: 'AI-Assisted Development, Prompt Engineering, Claude, ChatGPT, GitHub Copilot',
    value: 90,
  },
  {
    label: 'Designing Tools',
    detail: 'Photoshop, Figma, Canva',
    value: 90,
  },
]
